export default "__VITE_ASSET__DNkV5c5t__"